import { Steps } from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { CheckIcon } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  edit?: boolean;
}

export default function RecommendedEdit(props: IProps): JSX.Element {
  const { children, isLoading, edit } = props;
  const step = useCategoryManagementStore((state) => state.step);
  const infoSteps = [
    {
      title: 'Khai báo danh mục',
      icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
      className: 'step-first',
    },
    {
      title: 'Thiết lập phê duyệt',
      icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
      className: 'step-last',
    },
  ];
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Chỉnh sửa');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Thiết lập</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/recommended-list">Danh mục khuyến nghị</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="">Chỉnh sửa</a>
          </p>
        ),
      },
    ]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Steps
        current={step}
        className="add-Allocate-step mb-7"
        items={infoSteps}
      />
      <div className="p-1">{children}</div>
    </MainLayout>
  );
}
